import type {ComboboxProps} from '@/components/ui/combobox';
import {Combobox} from '@/components/ui/combobox';
import {graphqlClient} from '@/services/graphqlClient';
import {useGetAllResidentsForInputQuery} from '@/services/graphqlHooks';

import type {ResidentOption} from '../utils/residentOptions';
import {renderResidentOption, toResidentOption} from '../utils/residentOptions';

export type AnyResidentInputProps = Omit<
  ComboboxProps<ResidentOption>,
  'items'
> & {
  value: string;
  onChange: (value: string) => void;
};

const AnyResidentInput = ({
  value,
  onChange,
  ...props
}: AnyResidentInputProps) => {
  const {data, isLoading} = useGetAllResidentsForInputQuery(
    graphqlClient,
    undefined,
    {staleTime: Infinity}
  );

  const residentOptions = (data?.getAllResidents || []).map(toResidentOption);
  const selectedItem =
    residentOptions.find(option => option.value === value) || null;

  return (
    <Combobox
      items={residentOptions}
      isLoading={isLoading}
      itemToString={option => option?.label || ''}
      selectedItem={selectedItem}
      onSelectedItemChange={({selectedItem}) => {
        onChange(selectedItem?.value || '');
      }}
      renderItem={renderResidentOption}
      {...props}
    />
  );
};

export default AnyResidentInput;
